const MAX_FONT_SIZE = 20;
const MIN_FONT_SIZE = 12;
const DEFAULT_FONT_SIZE = 16;
const FONT_SIZE_INCREMENT = 2;
const defaultSettings = {
    fontSize: DEFAULT_FONT_SIZE,
};
export const createSettingsSlice = (set) => ({
    settings: defaultSettings,
    increaseFontSize: () => set((state) => ({
        settings: {
            ...state.settings,
            fontSize: Math.min(state.settings.fontSize + FONT_SIZE_INCREMENT, MAX_FONT_SIZE),
        },
    })),
    decreaseFontSize: () => set((state) => ({
        settings: {
            ...state.settings,
            fontSize: Math.max(state.settings.fontSize - FONT_SIZE_INCREMENT, MIN_FONT_SIZE),
        },
    })),
});
// Selectors
export const selectFontSizeSetting = ({ settings: { fontSize } }) => ({
    fontSize,
});
// Actions
export const selectUpdateFontSize = ({ increaseFontSize, decreaseFontSize }) => ({
    increaseFontSize,
    decreaseFontSize,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0dGluZ3NTbGljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdGF0ZS9zbGljZXMvc2V0dGluZ3NTbGljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLGFBQWEsR0FBRyxFQUFFLENBQUM7QUFDekIsTUFBTSxhQUFhLEdBQUcsRUFBRSxDQUFDO0FBQ3pCLE1BQU0saUJBQWlCLEdBQUcsRUFBRSxDQUFDO0FBQzdCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxDQUFDO0FBRTlCLE1BQU0sZUFBZSxHQUFvQjtJQUN2QyxRQUFRLEVBQUUsaUJBQWlCO0NBQzVCLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBc0QsQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDOUYsUUFBUSxFQUFFLGVBQWU7SUFDekIsZ0JBQWdCLEVBQUUsR0FBRyxFQUFFLENBQ3JCLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNkLFFBQVEsRUFBRTtZQUNSLEdBQUcsS0FBSyxDQUFDLFFBQVE7WUFDakIsUUFBUSxFQUFFLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxRQUFRLEdBQUcsbUJBQW1CLEVBQUUsYUFBYSxDQUFDO1NBQ2pGO0tBQ0YsQ0FBQyxDQUFDO0lBQ0wsZ0JBQWdCLEVBQUUsR0FBRyxFQUFFLENBQ3JCLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNkLFFBQVEsRUFBRTtZQUNSLEdBQUcsS0FBSyxDQUFDLFFBQVE7WUFDakIsUUFBUSxFQUFFLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxRQUFRLEdBQUcsbUJBQW1CLEVBQUUsYUFBYSxDQUFDO1NBQ2pGO0tBQ0YsQ0FBQyxDQUFDO0NBQ04sQ0FBQyxDQUFDO0FBRUgsWUFBWTtBQUNaLE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUFHLENBQUMsRUFBRSxRQUFRLEVBQUUsRUFBRSxRQUFRLEVBQUUsRUFBZ0IsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNsRixRQUFRO0NBQ1QsQ0FBQyxDQUFDO0FBRUgsVUFBVTtBQUNWLE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLENBQUMsRUFBRSxnQkFBZ0IsRUFBRSxnQkFBZ0IsRUFBZ0IsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM3RixnQkFBZ0I7SUFDaEIsZ0JBQWdCO0NBQ2pCLENBQUMsQ0FBQyJ9